<template>
  <div class="weather-info">
    <div class="weather-details" v-if="weatherInfo.data">
      <div v-for="(item, index) in weatherInfo.data" :key="index" class="item">
        <div class="left-side" v-if="index === '6-12'">
          <div><p>Förmiddag</p></div>
        </div>
        <div class="left-side" v-if="index === '12-17'">
          <div><p>Eftermiddag</p></div>
        </div>
        <div class="left-side" v-if="index === '17-22'">
          <div><p>Kväll</p></div>
        </div>
        <div class="right-side">
          <div style="display: flex; margin-left: 10px">
            <p>{{ kelvinToCelsius(item.temp) }}°c</p>
          </div>
          <div style="display: flex; margin-left: 10px">
            <p>0,1mm</p>
            &nbsp;
            <p style="font-weight: lighter">( {{ item.humidity }}% )</p>
          </div>
          <div style="display: flex; margin-left: 10px">
            <p>{{ item.speed }} m/s</p>
            &nbsp;
            <p style="font-weight: lighter">( {{ item.pressure }}hPA)</p>
          </div>
        </div>
      </div>
    </div>
    <div class="not-found" v-if="weatherInfo.message">
      {{ $t('Weather data missing') }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'Weather',
  data() {
    return {
      weatherInfo: { status: 'ok', data: {} },
    };
  },
  props: ['currentdate', 'city'],
  methods: {
    /**
     * convart kelvin To Celsius.
     */
    kelvinToCelsius: function (val) {
      var k = val - 273.15;
      return k.toFixed(1);
    },
    /**
     * currentdate weather data.
     */
    weatherAPI: function () {
      if (this.city) {
        Vue.axios
          .get(`https://api.h2.strativ-support.se/history/?city=${this.city}&date=${this.currentdate}`)
          .then((response) => {
            if (response.data) {
              this.weatherInfo = response.data;
            }
            console.log(JSON.stringify(this.weatherInfo));
          });
      }
    },
  },
  computed: {
    temperatureMax: function () {
      return this.kelvinToCelsius(this.weatherInfo.main.temp_max);
    },
    temperatureMin: function () {
      return this.kelvinToCelsius(this.weatherInfo.main.temp_min);
    },
    weatherImageUrl: function () {
      return 'static/icon/' + this.weatherInfo.weather[0].icon + '.png';
    },
    humidity: function () {
      return this.weatherInfo.main.humidity;
    },
    pressure: function () {
      return this.weatherInfo.main.pressure;
    },
    windSpeed: function () {
      return this.weatherInfo.main.wind.speed;
    },
  },
  watch: {
    currentdate: function () {
      this.weatherAPI();
    },
  },
  mounted: function () {
    this.weatherAPI();
    console.log(JSON.stringify(this.$route.matched[0].path));
  },
};
</script>
<style>
.weather-date {
  border-bottom: 0;
  display: flex;
  flex-direction: column;
}

.weather-details {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 30px;
}
.weather-details .item {
  display: flex;
}
.weather-info .right-side {
  padding-left: 10px;
}
.weather-info .right-side div:nth-child(2) {
  width: 105px;
}
.weather-info .right-side div:nth-child(3) {
  width: 150px;
}
.weather-info .left-side,
.weather-info .right-side {
  display: flex;
  flex-direction: row;
}
.weather-info .left-side img,
.weather-info .right-side img {
  width: 55px;
  height: 55px;
}
.weather-details .left-side p {
  width: 65px;
}
.weather-date .light {
  font-weight: 400;
  font-family: Montserrat;
}
.weather-date .bold {
  font-weight: bold;
  font-family: 'Montserrat';
}
.weather-details p {
  font-size: 12px;
  font-weight: bold;
  white-space: nowrap;
}
.weather-details .temp {
  font-weight: bold;
  margin-bottom: 5px;
}
.weather-info .bar {
  background: #253747;
  width: 1px;
}
.weather-info .not-found {
  color: red;
  padding: 5px 0;
  /* align-self: center; */
}
@media (max-width: 768px) {
  .weather-details {
    margin-bottom: 5px;
    width: 245px;
    flex-wrap: wrap;
    flex-direction: row;
  }
  .weather-details p {
    font-size: 11px;
  }
  .weather-details .item {
    display: flex;
    flex-direction: column;
  }
  .weather-info .left-side,
  .weather-info .right-side {
    flex-direction: column;
  }
  .weather-info .not-found {
    border-top: 1px solid #253747;
    border-bottom: 1px solid #253747;
    align-self: unset;
  }
}
@media (max-width: 540px) {
  .weather-details {
    width: 100%;
    flex-wrap: unset;
    flex-direction: row;
  }
  .weather-info .right-side {
    padding-left: 0;
  }
  .weather-details .right-side div {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/diary/Weather.vue